import { AuthenticationError, AuthService } from "@/services/auth.service";
import { TokenService } from "@/services/token.service";

const state = {
    authenticating: false,
    accessToken: TokenService.getToken(),
    authenticationErrorCode: 0,
    authenticationError: "",
    refreshTokenPromise: null,
    user: null
};

const getters = {
    authenticationErrorCode: (state: { authenticationErrorCode: any }) => {
        return state.authenticationErrorCode;
    },

    authenticationError: (state: { authenticationError: any }) => {
        return state.authenticationError;
    },

    authenticating: (state: { authenticating: any }) => {
        return state.authenticating;
    },

    user: (state: { user: any }) => {
        return state.user;
    }
};

const actions = {
    async signIn(context: any, signInData: any) {
        context.commit("signInRequest");
        return new Promise((resolve, reject) => {
            AuthService.signIn(signInData)
                .then((res: any) => {
                    context.commit("signInSuccess", res);
                    resolve(res);
                })
                .catch((err: any) => {
                    if (err instanceof AuthenticationError) {
                        context.commit("signInError", {
                            errorCode: err.errorCode,
                            errorMessage: err.message
                        });
                        reject(err);
                    }
                });
        });
    },

    async getUser(context: any) {
        return new Promise((resolve, reject) => {
            AuthService.getUser()
                .then((res: any) => {
                    context.commit("userSuccess", res);
                    resolve(res);
                })
                .catch((err: any) => {
                    if (err instanceof AuthenticationError) {
                        context.commit("signInError", {
                            errorCode: err.errorCode,
                            errorMessage: err.message
                        });
                        reject(err);
                    }
                });
        });
    },

    async signOut(context: any) {
        context.commit("signOutRequest");
        return new Promise((resolve: any) => {
            AuthService.signOut();
            context.commit("userUnset");
            resolve();
        });
    },

    async refreshToken(context: any, state: { refreshTokenPromise: any }) {
        if (!state.refreshTokenPromise) {
            const p = AuthService.refreshToken();
            context.commit("refreshTokenPromise", p);

            p.then(
                (response: any) => {
                    context.commit("refreshTokenPromise", null);
                    context.commit("loginSuccess", response);
                },
                (error: any) => {
                    context.commit("refreshTokenPromise", error);
                }
            );
        }

        return state.refreshTokenPromise;
    },

    async signUp(context: any, data: any) {
        context.commit("signInRequest");
        return new Promise((resolve, reject) => {
            AuthService.signUp(data)
                .then((res: any) => {
                    context.commit("processSuccess");
                    resolve(res);
                })
                .catch((err: any) => {
                    if (err instanceof AuthenticationError) {
                        context.commit("signInError", {
                            errorCode: err.errorCode,
                            errorMessage: err.message
                        });
                        reject(err);
                    }
                });
        });
    },

    setAuthenticatingStatus(context: any, status: any) {
        context.commit("setAuthenticatingStatus", status);
    },
};

const mutations = {
    signInRequest(state: {
        authenticating: boolean;
        authenticationError: string;
        authenticationErrorCode: number;
    }) {
        state.authenticating = true;
        state.authenticationError = "";
        state.authenticationErrorCode = 0;
    },

    signInSuccess(state: {
        accessToken: any;
        authenticating: boolean;
    }, accessToken: any) {
        state.accessToken = accessToken;
        state.authenticating = false;
    },

    userSuccess(state: {
        user: any;
    }, user: any) {
        state.user = user;
    },

    signInError(state: {
        authenticating: boolean;
        authenticationErrorCode: any;
        authenticationError: any;
    }, {errorCode, errorMessage}: any) {
        state.authenticating = false;
        state.authenticationErrorCode = errorCode;
        state.authenticationError = errorMessage;
    },

    signOutRequest(state: { authenticating: boolean }) {
        state.authenticating = false;
    },

    userUnset(state: {
        user: any;
    }) {
        state.user = null;
    },

    refreshTokenPromise(state: { refreshTokenPromise: any }, promise: any) {
        state.refreshTokenPromise = promise;
    },

    processSuccess(state: { authenticating: boolean }) {
        state.authenticating = false;
    },

    setAuthenticatingStatus(state: { authenticating: any }, status: any) {
        state.authenticating = status;
    }
};

export const auth = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
